module.exports = __webpack_public_path__ + "img/2012-09-06 (FF 21) Montage Holzelemente.fbbef7f0.jpg";